import React from 'react';

import {Select, styled} from '@volkswagen-onehub/components-core';
import {
  type BffResponse,
  type Filter,
  TRIM_FILTER,
} from '@volkswagen-onehub/car-technical-details-bff';
import {loadBff} from '../loadBff';
import {useTrackingService} from '../utils/useTrackingService';

const StyledSelectWrapper = styled.div`
  display: flex;
  margin-right: auto;
  min-width: 25%;
  width: auto;
`;

export const TrimFilter = (props: {
  filter: Filter;
  bffUrl: string;
  setBffResponse: React.Dispatch<React.SetStateAction<BffResponse>>;
}): JSX.Element => {
  const {filter, bffUrl} = props;
  const trackingService = useTrackingService();

  const onChangeHandler = React.useCallback(
    (event: React.SyntheticEvent<HTMLSelectElement, Event>) => {
      const {value} = event.target as HTMLOptionElement;

      trackingService.trackTrimFilterClick([value]);
      const url = new URL(bffUrl);
      url.searchParams.set('defaultTrim', value);
      loadBff(url.toString()).then((response) => {
        if (response) {
          props.setBffResponse(response);
          return response;
        }

        throw 'failure';
      });
    },
    [bffUrl, props, trackingService],
  );

  return (
    <StyledSelectWrapper>
      <Select
        key={filter.key}
        name={filter.name}
        label={filter.label}
        defaultValue={filter.defaultOption}
        onChange={(event) => onChangeHandler(event)}
      >
        {filter.options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </Select>
    </StyledSelectWrapper>
  );
};

// TODO: will be migrated to a proper react based solution
export function getSelectedValue(): string | undefined {
  let value;
  const trimFilter = document.getElementsByName(TRIM_FILTER);
  if (trimFilter && trimFilter.length == 1) {
    value = (trimFilter[0] as HTMLSelectElement).value;
  }

  return value;
}

export default TrimFilter;
